/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {Component} from 'react';

import {connect} from 'react-redux';

import {UpdateDevicePowerStatus} from '@/actions/deviceActions';
import * as deviceInfoActions from '@/actions/deviceInfoActions';
import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import AutoProfileLogo from '@/assets/icons/AutoProfile.svg';
import CleaningWizard from '@/assets/icons/CleaningWizard.svg';
import SequenceRunnerLogo from '@/assets/icons/ManualProfile.svg';
import ProfileHistoryLogo from '@/assets/icons/ProfileHistory.svg';
import InfoSuport from '@/assets/icons/si-glyph-float.svg';
import SystemSettingLogo from '@/assets/icons/SystemSettings.svg';
import PcLogo from '@/assets/images/LogoPC.png';
import TextLogo from '@/assets/images/PulseTextLogo.png';
import Button from '@/components/button/Button';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventLicenseService} from '@/constants/pubSubEnum';
import {consoleLog} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';
import {eventBusObject} from '@/observers/eventBus';

import WifiStatusButton from './WifiStatusButton';

import './HomeScreen.less';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
  // lockAccess: store.setupStore.lockAccess,
  licenseStatus: store.deviceInfoStore.licenseStatus,
  licenseType: store.deviceInfoStore.licenseType,
}))
class HomeScreen extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.onClickShutDown = this.onClickShutDown.bind(this);
    this._bus = eventBusObject();
    this.successShutDown = this.successShutDown.bind(this);
    this.failedShutDown = this.failedShutDown.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.HOME));
  }

  onClickShutDown(e) {
    const {id} = e.currentTarget;
    this.props.dispatch(modalActions.hidePopUp());
    switch (id) {
      case APPDATA.OK: {
        this.props.dispatch(
          loadingActions.updateLoading({
            showLoading: true,
            loadingText: APPDATA.MESSAGES.SHUTTINGDOWN,
            // loadingButton1: {
            //     label: APPDATA.CLOSE,
            //     onClick: () => {
            //         this.props.dispatch(loadingActions.showLoading(false));
            //     },
            // },
          }),
        );
        this.props.dispatch(UpdateDevicePowerStatus(APPDATA.POWER.OFF));

        if (typeof this._statusServicePooling !== 'undefined') {
          clearInterval(this._statusServicePooling);
          this._statusServicePooling = undefined;
        }
        const param = {};
        const passingVariable = {};
        Post(APPDATA.API.POST_SHUT_DOWN, param, this.successShutDown, passingVariable, () => {}, this.failedShutDown);
        break;
      }
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
  }

  onClick(e) {
    switch (e.currentTarget.id) {
      case APPDATA.SHUT_DOWN: {
        const popUpButton = [
          {
            id: APPDATA.OK,
            isPrimaryButton: true,
            onClick: this.onClickShutDown,
            label: APPDATA.OK,
          },
          {
            id: APPDATA.CANCEL,
            isPrimaryButton: false,
            onClick: this.onClickShutDown,
            label: APPDATA.CANCEL,
          },
        ];
        this.props.dispatch(
          modalActions.showPopUp({
            popUpTitle: 'Shutdown',
            popUpText: APPDATA.MESSAGES.SHUTDOWN,
            popUpQuestion: '',
            popUpButton,
          }),
        );
        break;
      }
      case APPDATA.AUTO_PROFILE_SETUP_TAB:
        window.location.href = APPDATA.AUTO_PROFILE_SETUP;
        break;
      case APPDATA.CYCLE_HISTORY:
        window.location.href = APPDATA.CYCLE_HISTORY_ADDRESS;
        break;
      case APPDATA.SYSTEM_LOGS:
        window.location.href = APPDATA.SYSTEM_LOGS_ADDRESS;
        break;
      case APPDATA.SYSTEM_SETTING:
        window.location.href = APPDATA.DEVICE_SETTING_ADDRESS;
        break;
      case APPDATA.INFO_AND_SUPPORT:
        window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
        break;
      case APPDATA.CLEANING_WIZARD:
        window.location.href = APPDATA.CLEANING_WIZARD_ADDRESS;
        break;
      case APPDATA.CALIBRATION_VOLUME_SENSOR:
        window.location.href = APPDATA.CALIBRATION_VOLUME_SENSOR_WIZARD_ADDRESS;
        break;
      case APPDATA.MANUAL_PROFILE:
        window.location.href = APPDATA.MANUAL_PROFILE_ADDRESS;
        break;
      default:
        break;
    }
  }

  successShutDown() {
    consoleLog('success shutdown');
    this.props.dispatch(loadingActions.showLoading(false));
    window.location.href = APPDATA.SHUTDOWN_PAGE_ADDRESS;
  }

  failedShutDown = () => {
    consoleLog('failed shutdown');
    this.props.dispatch(UpdateDevicePowerStatus(APPDATA.POWER.ON));
    this.props.dispatch(loadingActions.showLoading(false));
  };

  onClickDemoButton = () => {
    consoleLog('Demo Button Clicked ');
    const popUpButton = [
      {
        id: APPDATA.ACTIVATE,
        label: APPDATA.ACTIVATE,
        isPrimaryButton: true,
        onClick: this.onClickButtonDemoModal,
      },
      // {
      //   id: APPDATA.CANCEL,
      //   label: APPDATA.CANCEL,
      //   isPrimaryButton: false,
      //   onClick: this.onClickButtonDemoModal,
      // },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TITLE,
        popUpText: newLineHtml(APPDATA.MESSAGES.LICENSE.MODAL_DEMO.TEXT),
        popUpButton,
        popUpHideCloseButton: true,
      }),
    );
  };

  onClickButtonDemoModal = (e) => {
    this.props.dispatch(modalActions.hidePopUp());
    switch (e.currentTarget.id) {
      case APPDATA.ACTIVATE:
        window.location.href = APPDATA.INFO_AND_SUPPORT_ADDRESS;
        this.props.dispatch(deviceInfoActions.updateLicenseActivationMode(APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE));
        this._bus.publish(EventLicenseService.LicenseModalService, {
          licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE,
        });
        break;
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
  };

  render() {
    const disableShutdown = !!this.props.isPCRunning; // this.props.lockAccess ? true : !!this.props.isPCRunning;
    const {licenseStatus, licenseType} = this.props;
    const isDemoMode = !(
      (licenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
        licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
      licenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
    );
    // consoleLog("isDemoMode", {licenseStatus, licenseType, isDemoMode});
    return (
      <div className="homeScreen ">
        {/* <div className = "row rowShutDown">
                    <Button id = {APPDATA.SHUT_DOWN} onClick = {this.onClick} className ="glyphicon glyphicon-off shutdown" disabled = {disableShutdown}/>
                </div> */}
        <div className="rowButton">
          <WifiStatusButton />
          {isDemoMode ? (
            <Button
              id="demoButton"
              onClick={this.onClickDemoButton}
              className="demoButtonHomeScreen demoButton"
              // disabled={false}
              label={APPDATA.INACTIVE_LICENSE}
            />
          ) : null}
          <Button
            id={APPDATA.SHUT_DOWN}
            onClick={this.onClick}
            className="glyphicon glyphicon-off shutdown"
            disabled={disableShutdown}
          />
        </div>

        <div className="rowLogo">
          <img
            src={PcLogo}
            alt={PcLogo}
            className="logo"
          />
        </div>
        <div className="rowTitle">
          <span className="title">
            {/* {APPDATA.PRODUCT_NAME.replace("®", "")} TFF <sup>®</sup> */}
            <img
              src={TextLogo}
              alt={TextLogo}
              className="logo"
            />
          </span>
        </div>
        <div className="rowMenuButton">
          <div className="center">
            <div className="col-md-4 colButton">
              <Button
                id={APPDATA.AUTO_PROFILE_SETUP_TAB}
                onClick={this.onClick}
                icon={AutoProfileLogo}
                iconClassName="icon"
                className="button center"
                label={APPDATA.AUTO_PROFILE.toUpperCase()}
              />
              {/* <div className="buttonText">
								<span>{APPDATA.AUTO_PROFILE}</span>
							</div> */}
            </div>
            <div className="col-md-3 colButton">
              <Button
                id={APPDATA.MANUAL_PROFILE}
                onClick={this.onClick}
                icon={SequenceRunnerLogo}
                iconClassName="icon"
                className="button center"
                label={APPDATA.MANUAL_PROFILE.toUpperCase()}
              />
              {/* <div className="buttonText">
								<span>{APPDATA.MANUAL_PROFILE.toUpperCase()}</span>
							</div> */}
            </div>
            <div className="col-md-4 colButton">
              <Button
                id={APPDATA.CLEANING_WIZARD}
                onClick={this.onClick}
                icon={CleaningWizard}
                iconClassName="icon"
                className="button center"
                label={APPDATA.CLEANING_WIZARD.toUpperCase()}
              />
              {/* <div className="buttonText">
								<span>{APPDATA.CLEANING_WIZARD}</span>
							</div> */}
            </div>
          </div>
          <br />
          <div className="center">
            <div className="col-md-4 colButton">
              {/* <Button
                id={APPDATA.CYCLE_HISTORY}
                onClick={this.onClick}
                icon={ProfileHistoryLogo}
                iconClassName="icon"
                className="button center"
                label={APPDATA.CYCLE_HISTORY.toUpperCase()}
              /> */}

              <Button
                id={APPDATA.SYSTEM_LOGS}
                onClick={this.onClick}
                icon={ProfileHistoryLogo}
                iconClassName="icon"
                className="button center"
                label={APPDATA.SYSTEM_LOGS_SHORT.toUpperCase()}
              />
              {/* <div className="buttonText">
								<span>{APPDATA.CYCLE_HISTORY}</span>
							</div> */}
            </div>
            <div className="col-md-3 colButton">
              <Button
                id={APPDATA.SYSTEM_SETTING}
                onClick={this.onClick}
                icon={SystemSettingLogo}
                iconClassName="icon"
                className="button center"
                label={APPDATA.SYSTEM_SETTING.toUpperCase()}
              />
              {/* <div className="buttonText">
								<span>{APPDATA.SYSTEM_SETTING}</span>
							</div> */}
            </div>
            <div className="col-md-4 colButton">
              <Button
                id={APPDATA.INFO_AND_SUPPORT}
                onClick={this.onClick}
                icon={InfoSuport}
                iconClassName="icon"
                className="button center"
                label="INFO &amp; SUPPORT"
              />
              {/* <div className="buttonText">
								<span>INFO &amp; SUPPORT</span>
							</div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default HomeScreen;
